<template>
  <sale-profile
    v-if="$route.query.saleId"
    :id="$route.query.saleId"
  />

  <post-view
    v-else-if="$route.query.postId"
    :id="$route.query.postId"
  />

  <showcase-profile
    v-else-if="$route.query.showcaseCardId"
    :id="$route.query.showcaseCardId"
  />

  <card-sales
    v-else-if="$route.query.showSales"
    :id="$route.query.cardId || $route.params.id"
  />

  <profile-profile
    v-else-if="$route.query.profileId"
    :profile-id="$route.query.profileId"
  />

  <card-profile
    v-else-if="$route.query.cardId"
    :id="$route.query.cardId"
    :profile-type="$route.query.profile"
  />
</template>

<script>
import CardProfile from '@/cards/CardProfile';
import CardSales from '@/cards/CardSales';
import SaleProfile from '@/sales/SaleProfile';
import ProfileProfile from '@/profiles/ProfileProfile';
import PostView from '@/feed/PostView';
import ShowcaseProfile from '@/showcase/ShowcaseProfile';

const PANEL_KEYS = [
  'cardId',
  'saleId',
  'profileId',
  'postId',
  'showcaseCardId',
  'showSales',
  'index',
];

export default {
  components: {
    CardProfile,
    CardSales,
    SaleProfile,
    ProfileProfile,
    PostView,
    ShowcaseProfile,
  },

  watch: {
    $route(to, from) {
      this.handleRouteSidePanel(to, from);
    },
  },

  methods: {
    handleRouteSidePanel(to, from) {
      if ((to.query.cardId && from.query.cardId && to.query.cardId !== from.query.cardId)
        || (to.params.id && from.params.id && to.params.id !== from.params.id)) {
        this.cleanRouteQuery(['cardId', 'showSales']);
      } else if (to.query.saleId && to.query.saleId !== from.query.saleId) {
        this.cleanRouteQuery(['saleId', 'index']);
      } else if (to.query.profileId && from.query.profileId && to.query.profileId !== from.query.profileId) {
        this.cleanRouteQuery(['profileId']);
      } else if (to.query.postId && to.query.postId !== from.query.postId) {
        this.cleanRouteQuery(['postId']);
      } else if (to.query.showcaseCardId && to.query.showcaseCardId !== from.query.showcaseCardId) {
        this.cleanRouteQuery(['showcaseCardId']);
      } else if (to.query.showSales && to.query.showSales !== from.query.showSales) {
        this.cleanRouteQuery(['cardId', 'showSales']);
      }
    },

    cleanRouteQuery(except = []) {
      const query = { ...this.$route.query };

      PANEL_KEYS
        .filter((panelKey) => !except.includes(panelKey))
        .forEach((panelKey) => {
          delete query[panelKey];
        });

      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
